'use strict';

angular.module('imagetrend.components')
    .directive('hlpDeficiency', ['Format', 'IPDeficiencies', function (Format, IPDeficiencies) {
        return {
            restrict: 'AE',
            scope: {
                ngModel: '=',
                resultSet: '=?',
                deficiency: '=?',
                deficiencyId: '=?',
                classes: '@?',
                resultClick: '&',
                isRequired: '=?',
                requiredText: '@?',
                number: '@?',
                expandable: '=?',
                pdf: '=?'
            },
            replace: true,
            transclude: true,
            require: 'ngModel',
            templateUrl: 'templates/deficiency/deficiency.html',
            link: function (scope, elem, attrs, ctrl) {

                if (!attrs.requiredText || attrs.requiredText == "") {
                    scope.reqText = 'Please select a result' + (scope.deficiency ? "for " + scope.deficiency.question : "");
                } else {
                    scope.reqText = attrs.requiredText;
                }

                scope.resultSet.sort(function (a, b) {
                    if (a.fail === b.fail) {
                        if (a.abbr < b.abbr) { return -1; }
                        else if (a.abbr > b.abbr) { return 1 }
                        else { return 0 }
                    }
                    else if (a.fail < b.fail) { return -1; }
                    else if (a.fail > b.fail) { return 1 }
                    else { return 0 }
                })

                scope.$watch('deficiencyId', function (id) {
                    if (id != null) {
                        IPDeficiencies.getByID(id).then(function (deficiency) {
                            scope.deficiency = deficiency;
                        });
                    }
                });

                if (scope.ngModel && scope.ngModel.deficiency) {
                    scope.deficiency = scope.ngModel.deficiency;
                }

                scope.onChange = function (item) {
                    scope.submitted = false;
                    ctrl.$setViewValue(item);
                }

                scope.submitted = false;
                scope.$on('form:submit', function () {
                    scope.submitted = true;
                });

                scope.$on('$destroy', function () {
                    if (elem) {
                        angular.element(elem).off();
                        angular.element(elem).remove();
                        elem = null;
                    }
                });
            },
            controller: ['$scope', function ($scope) {

            }]
        };
    }])

    ;
